module.exports = __webpack_public_path__ + "static/media/30.34c926de.svg";